import cn from "@/v2-ui/utils/utils.cn"
import { getFlagAssetUrl } from "@/v2-ui/utils/utils.assets"

export type CountryFlagProps = {
  className?: string
  alpha2: string
  name?: string | null
}

// The flag for a country, sized to sit inline with a line of text.
function CountryFlag(props: CountryFlagProps) {
  const { className, alpha2, name } = props

  return (
    <img
      className={cn(
        "h-3 w-[18px] shrink-0 rounded-[2px] object-cover",
        className,
      )}
      src={getFlagAssetUrl(alpha2.toLowerCase())}
      alt={name ?? alpha2}
    />
  )
}

export default CountryFlag
